<infl-widget-wrapper [widget]="widget()" [actions]="actions">
  <div class="wrapper">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 304.6 343.2"
    >
      <defs>
        <style>
          .cls-1 {
            fill: #f49aa4;
          }

          .cls-2 {
            fill: #ffce54;
          }

          .cls-3 {
            fill: #ed5565;
          }

          .cls-4 {
            fill: #faaa0a;
          }

          .cls-5 {
            fill: #ffffff;
          }

          .cls-6 {
            fill: #fafafa;
          }

          .cls-7 {
            fill: #2f373a;
          }

          .cls-8 {
            fill: #c8c8c8;
          }
        </style>
      </defs>
      <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
      <g>
        <g id="Calque_1">
          <path
            id="Tracé_1045"
            class="cls-7"
            d="M281.3,334.8c-18.8,10.4-54.6,8.3-122,8.3s-137.4.3-122-8.3,54.6-8.3,122-8.3,140.8-2.1,122,8.3Z"
          />
          <path
            class="cls-7"
            d="M287.2,55.4h0c-5.4,0-9.8,4.4-9.8,9.8,0,2.3.8,4.4,2.2,6.2l-21,40.2-2.5-1.1c2.5-8.7,2.4-16.8,0-22.2l6.3-11.5c.5-1,.4-2.2-.5-3l-27.5-26.4s0,0,0,0c0,0-.1-.1-.2-.2,0,0-.1,0-.2-.1,0,0-.1,0-.2-.1,0,0-.2,0-.3-.1,0,0,0,0,0,0-24.7-7.9-50.2-13.1-76-15.5l.5-6.5c0-1.2-.7-2.3-1.9-2.6-22.6-5.4-51.4-1.1-52.6-.9-1.2.2-2.1,1.2-2.1,2.5v7.6c-22.3,2.3-42.6,7.5-60.7,15.6-1,.4-1.6,1.4-1.5,2.5l1.8,22.4c-7.2,5.4-10.2,14.2-9,26.1l-7,1.2-8.4-36.7c4.4-3.1,5.5-9.3,2.3-13.7-3.1-4.4-9.3-5.5-13.7-2.3-4.4,3.1-5.5,9.3-2.3,13.7,1.5,2.1,3.8,3.6,6.4,4l9.2,40.2c.4,1.7,1.9,2.9,3.7,2.9.2,0,.4,0,.6,0l10.4-1.8c2.3,10.2,6.5,14.9,12,18.2l1.5,19.1c.1,1.3,1.1,2.3,2.4,2.3l36,1.3v.5c-9.9,5.8-19.2,12.5-27.8,19.9-.2.1-.3.2-.5.4-9.5,8.4-17.6,18.1-17.6,26.7,0,2.5.5,5,1.4,7.4,0,.1,0,.2.1.3,2.5,6.6,8,12.8,14,18.2.3.5.7.8,1.2,1,2.4,2,4.8,3.9,7.1,5.6-1,1.6-1.7,3.3-2.2,5.1,0,.4,0,.8,0,1.2.2.8,2.5,7.9,15.3,12.6-.2.9-.3,1.8-.4,2.8l-2.8,65.4h-17.6c-1.3,0-2.5,1.1-2.5,2.4l-.7,17.7c0,1.4,1,2.6,2.4,2.6,0,0,0,0,.1,0h63.2c1.3,0,2.5-1.1,2.5-2.4l.7-17.7,1.5-38h17.9c1.4,0,2.8-.3,4.1-.8l1.9,36.2h-11.2c-1.4,0-2.5,1.1-2.5,2.5,0,0,0,0,0,.1l1,17.7c0,1.3,1.2,2.4,2.5,2.4h57c1.4,0,2.5-1.1,2.5-2.5,0,0,0,0,0-.1l-1-17.7-3.8-67.8c0-.7-.1-1.5-.3-2.2l.2.4c.4.9,1.3,1.4,2.3,1.4.2,0,.5,0,.7-.1,8.9-2.6,12.7-7.9,14.4-12.1,1.1-1,1.9-2.2,2.2-3.6,0,0,0-.1,0-.2,2.7-1.6,5.8-3.6,8.9-5.9,0,0,.1,0,.2-.1,11-8,22.7-19.4,22.5-29.8-.4-14.8-33.6-37-46.9-45.3l4.9.2h20.1c.9,0,1.8-.5,2.2-1.3l7.1-12.9c.2,0,.3.1.5.2,1,.4,2.1.6,3.2.6,7.1,0,15.1-7.9,20.2-19.4l5.3,2.2c1.8.8,3.9,0,4.8-1.7l22.5-43.2c.3,0,.7,0,1,0,5.4,0,9.8-4.4,9.8-9.8s-4.4-9.8-9.8-9.8ZM80.1,200c-1.1-.6-2.4-1.2-3.6-1.9,0,0,0,0-.1,0-3.7-2.2-7.4-4.9-8.8-7.4.6-2,2.8-5,5.6-8.1,0,0,.1-.1.2-.2,2.9-3.2,6-6.3,9.3-9.2l-2.5,26.9ZM197.3,184.9l7.2,5.9h0s2.7,2.2,2.7,2.2c-.7.3-1.4.6-2,.8,0,0,0,0,0,0-3,1.2-5.8,2.4-7.9,3.3v-12.3Z"
          />
          <path
            id="Tracé_1053"
            class="cls-4"
            d="M149.2,318.3h-11.2l.7,12.7h32.5l-.7-12.7h-21.3Z"
          />
          <path
            id="Tracé_1055"
            class="cls-4"
            d="M57.8,318.3l-.5,12.7h34.7l.5-12.7h-34.7Z"
          />
          <polygon
            class="cls-2"
            points="57.8 318.3 57.3 331 62.2 331 63.2 318.3 57.8 318.3"
          />
          <polygon
            class="cls-4"
            points="170 149.4 90.1 146.5 82.3 231.1 88.7 231.1 88.7 231.1 165.7 231.1 170 149.4"
          />
          <path
            id="Tracé_1046"
            class="cls-4"
            d="M155.5,36.2c-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.3,0-.6,0-.8-.2-8.1-.7-16.6-1.1-25.2-1.1-31.8,0-60.2,5.3-84.4,15.8l5.7,70.4c.1.4.2.9.1,1.3l1.4,17.5,146.9,5.5,31.1-94.6c-24.1-7.5-49-12.4-74.1-14.6Z"
          />
          <path
            id="Tracé_1048"
            class="cls-3"
            d="M98.5,318.2c-.2,0-.4,0-.6,0h-.3l-.5,12.7h18.4l.5-12.7h-16.9c-.2,0-.4,0-.6,0Z"
          />
          <polygon
            class="cls-2"
            points="138.7 331 144.5 331 143.4 318.3 138 318.3 138.7 331"
          />
          <path
            id="Tracé_1078"
            class="cls-4"
            d="M233.9,53.8l-12.9,39.1c5.1-8.1,12.6-13.2,19.8-13.2,1.7,0,3.4.3,5,.9.8.3,1.6.7,2.3,1.1,1.7.2,3.4.9,4.7,2.1l4.2-7.7-23.2-22.3Z"
          />
          <path
            id="Tracé_1079"
            class="cls-3"
            d="M175.5,318.3l.7,12.7h14.5l-.7-12.7h-14.5Z"
          />
          <path
            class="cls-2"
            d="M50.3,54.5c64.4-29.7,165.9-3.3,178.1,0l1.2-3.7c-24.1-7.5-49-12.4-74.1-14.6-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.3,0-.6,0-.8-.2-8.1-.7-16.6-1.1-25.2-1.1-31.8,0-60.2,5.3-84.4,15.8l5.7,70.4c.1.4.2.9,0,1.3l1.4,17.5h3c0,.1,0,.1,0,.1l-4.3-85.6Z"
          />
          <path
            id="Tracé_1085"
            class="cls-4"
            d="M214.7,112.3l-10.9,33.3h15.1l6.1-11c-7.1-3.2-10.8-12.1-10.2-22.3Z"
          />
          <path
            id="Tracé_1110"
            class="cls-7"
            d="M127.6,173.8l36.8,3.4c0,0,.2,0,.2,0,1.3,0,2.4-1,2.5-2.3.4-4.7-.7-9.3-3.2-13.3,0,0,0,0,0-.1-3.5-5.4-9.3-8.9-15.7-9.5-.7,0-1.3,0-2,0-10.8,0-19.9,8.2-20.9,19-.1,1.4.9,2.6,2.3,2.7h0Z"
          />
          <path
            id="Tracé_1118"
            class="cls-7 eyebrow eyebrow-left"
            d="M57,33c1.7,1.3,4,.9,5.3-.7,0,0,0,0,0,0,2.9-3.9,5.9-6,8.8-6.3,2.1-.1,4.2.6,5.8,1.9,1.5,1.4,3.9,1.3,5.3-.2,1.4-1.5,1.3-3.8-.1-5.3-3.1-2.8-7.3-4.3-11.5-4-5.2.4-10,3.5-14.3,9.2-1.3,1.7-.9,4,.7,5.3,0,0,0,0,0,0Z"
          />
          <path
            id="Tracé_1119"
            class="cls-7 eyebrow eyebrow-right"
            d="M184.8,29.1s4.6-3.5,9.6-2.7c3,.5,5.8,2.4,8.2,5.8,1.2,1.7,3.5,2.2,5.2,1,1.7-1.2,2.2-3.5,1-5.2,0,0,0,0,0,0-3.6-5.1-8.1-8.1-13.3-8.9-8.2-1.2-15,4-15.3,4.2-1.6,1.3-1.9,3.6-.7,5.3s3.6,1.9,5.3.7h0Z"
          />
          <path
            id="Tracé_1126"
            class="cls-7 fa-fade"
            d="M298.5,11l-13.8,23.7,7.9,3.5-2,12.7,14-19.5-7.4-2,1.3-18.4Z"
          />
          <path
            id="Tracé_1127"
            class="cls-7 fa-fade"
            d="M1.2,0L0,27.4l8.6-.5,4.1,12.2,3.4-23.8-7.5,1.6L1.2,0Z"
          />
          <path
            id="Tracé_1095"
            class="cls-4"
            d="M197.6,233.4c-.7-1.3-1-2.8-.8-4.2-2.4.8-4.7,1.8-7,3.1l4.7,9.6c2.8-1,5.3-2.8,7.2-5.1-1.8-.5-3.3-1.8-4.1-3.4Z"
          />
          <path
            id="Tracé_1051"
            class="cls-4"
            d="M174.4,227.8c4.6-4.5,13.2-10.7,25.4-10.4l-6.6-14.2c-3.9-.5-16.2-1.3-21.2,6.6l2.4,18Z"
          />
          <path
            class="cls-2"
            d="M172,209.8l2.4,18c2.1-2,5-4.4,8.6-6.3l-3.5-17.3c-3,1-5.7,2.7-7.5,5.6Z"
          />
          <path
            id="Tracé_1054"
            class="cls-4"
            d="M202.2,222.8v-.2c-13-1.3-21.8,6-25.5,10l2,.8c3.5-2.6,14-9.8,22.4-10.2.4-.2.8-.3,1.2-.4Z"
          />
          <g>
            <path
              class="cls-7"
              d="M176.2,124.1s0,0,0-.1c-.4-1.2-.9-2.3-1.5-3.3h0c-.1-.2-.3-.4-.4-.6l-13.8-13.8s0,0-.1,0c0,0-.1-.1-.2-.2,0,0-.1,0-.2-.1,0,0-.1,0-.2-.1,0,0-.1,0-.2,0s-.2,0-.2,0c0,0-.1,0-.2,0,0,0-.2,0-.3,0h-.2c0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0-18.5,10.2-41,10.2-59.5,0,0,0-.1,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.2.1,0,0-.1,0-.2.1,0,0-.2.1-.2.2,0,0,0,0,0,0l-11.9,11.9s0,0,0,.1-.1,0-.1.2c0,0,0,0,0,0,0,0,0,.1-.1.2,0,0,0,.2-.1.2,0,0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,.1,0,.2,0,.1,0,.2,0,.3,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,.5.5,1.6,1.8,3.6,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,.1.1.2.1,12.8,9.5,29.4,13.6,46.7,13.6s31.5-3.5,43.9-11.7h0s0,0,0,0c0,0,.2-.1.2-.2,0,0,0,0,.1-.1.1-.1.2-.2.3-.4,0,0,0-.2.1-.3,0,0,0-.1,0-.2,0-.1,0-.2.1-.4,0,0,0,0,0,0,0-.1,0-.2,0-.4,0,0,0,0,0-.1,0-.1,0-.3,0-.4Z"
            />
            <path
              class="cls-8"
              d="M168.5,121.4l-7.1-7.1c-.8.4-2.9,1.5-6.1,2.8l2.3,4.5c.6,1.2.1,2.8-1.1,3.4h0c-1.2.6-2.8.1-3.4-1.1h0s-2.4-4.8-2.4-4.8c0,0,0-.2-.1-.3-2.3.7-5,1.4-7.9,2,0,0,0,0,0,0l.9,5c.2,1.4-.7,2.7-2,2.9,0,0,0,0,0,0h0c-.1,0-.3,0-.5,0-1.2,0-2.3-.9-2.5-2.1l-.9-5s0,0,0-.1c-3,.4-6.1.7-9.5.7,0,0,0,0,0,.1v4.7c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5v-4.7c0,0,0-.2,0-.2-2.8-.1-5.7-.5-8.7-1,0,.1,0,.2-.1.4l-1.7,4.1c-.5,1.3-2,1.9-3.3,1.3s-1.9-2-1.3-3.3l1.5-3.6c-2.5-.6-5-1.3-7.6-2.3,0,0,0,.1-.1.2h0s-2.6,3.4-2.6,3.4c-.8,1.1-2.4,1.3-3.5.5-.5-.4-.8-.9-.9-1.5l-1.7,1.8c10.8,6.1,23.6,9.4,36.9,9.4,13.5,0,26.8-3.5,38.5-10.3Z"
            />
            <path
              class="cls-6"
              d="M150.4,117.3s0,0,0,0c0-.1,0-.3.1-.4,0,0,0,0,0,0,0-.1,0-.2.2-.3,0,0,0,0,0-.1,0,0,.1-.2.2-.2,0,0,.1-.1.2-.2,0,0,.1-.1.2-.2.1,0,.2-.2.4-.2,0,0,0,0,0,0,0,0,0,0,0,0h0c1.2-.6,2.8-.1,3.4,1.1v.3c3.4-1.3,5.5-2.3,6.2-2.8l-3.1-3.1c-9.4,4.9-19.9,7.4-30.5,7.4-10.6,0-21.1-2.5-30.5-7.4l-8.5,8.5c1.4.9,2.9,1.8,4.4,2.7l1.7-1.8c0-.3,0-.7,0-1,0,0,0,0,0,0,0-.2,0-.3.1-.5,0,0,0,0,0,0,0-.2.2-.3.3-.4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l2.6-3.4s0,0,0,0c.8-1.1,2.4-1.3,3.5-.5,0,0,0,0,0,0,0,0,0,0,.1.1,0,0,.2.1.2.2,0,0,0,.1.1.2,0,0,.1.1.2.2,0,0,0,.2.1.2,0,0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,.1,0,.2,0,.1,0,.2,0,.3,0,0,0,0,0,.1,0,.1,0,.2,0,.4,0,0,0,0,0,0,0,.1,0,.2-.1.4,0,0,0,0,0,0,0,.1-.1.2-.2.3,0,0,0,0,0,0,2.6.9,5.1,1.7,7.6,2.3l.2-.5c.5-1.3,2-1.9,3.3-1.3h0c1.2.5,1.8,1.7,1.5,2.9,3,.5,5.9.8,8.7,1,0-.5.2-.9.5-1.3,0,0,0,0,0,0,0-.1.2-.2.3-.3,0,0,0,0,0,0,0,0,.2-.1.3-.2,0,0,.1,0,.2,0,0,0,.2,0,.2-.1,0,0,.2,0,.3,0,0,0,0,0,.1,0,.2,0,.3,0,.5,0s.3,0,.5,0c0,0,0,0,0,0,.1,0,.3,0,.4.1,0,0,.1,0,.2,0,0,0,.2,0,.3.1,0,0,.2.1.2.2,0,0,0,0,.1.1,0,0,.2.2.2.3,0,0,0,0,0,0,0,.1.2.2.2.4,0,0,0,0,0,0,0,.1.1.3.2.4,0,0,0,0,0,0,0,.1,0,.3,0,.5,0,0,0,0,0,0,3.3,0,6.5-.3,9.5-.7,0,0,0,0,0,0,0-.1,0-.2,0-.4,0,0,0,0,0-.1,0-.1,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2.1-.3,0,0,0,0,0-.1,0-.1.2-.2.3-.3,0,0,0,0,0,0,.3-.3.8-.6,1.3-.7.3,0,.7,0,1,0,0,0,0,0,0,0,.1,0,.3,0,.4.1,0,0,.2,0,.3.2,0,0,0,0,.1,0,.5.4.9.9,1.1,1.6,2.9-.6,5.5-1.3,7.9-2-.2-.4-.2-.9,0-1.3Z"
            />
          </g>
          <path
            class="cls-7"
            d="M90.3,61.1c-3.9-2.4-8.5-3.8-13.4-3.8-14.2,0-25.6,11.5-25.6,25.6s6.3,19.6,15.4,23.5c3.9,2.4,8.5,3.8,13.4,3.8h0c14.2,0,25.6-11.5,25.6-25.6,0-10.5-6.3-19.6-15.4-23.5Z"
          />
          <path
            id="Tracé_1124"
            class="cls-6"
            d="M97.9,82.9c0,11.5-9.3,20.8-20.8,20.8s-20.8-9.3-20.8-20.8,9.3-20.8,20.8-20.8h0c11.5,0,20.8,9.3,20.8,20.8Z"
          />
          <circle
            id="left-eye-pupil"
            class="cls-7 pupil"
            cx="83"
            cy="83.3"
            r="14.9"
          />
          <path
            data-name="Tracé_1124"
            class="cls-6"
            d="M81.8,76.2c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3,2.4-5.3,5.3-5.3h0c2.9,0,5.3,2.4,5.3,5.3Z"
          />
          <path
            class="cls-7"
            d="M196.8,61.7c-4.1-2.7-9-4.3-14.3-4.3-14.2,0-25.6,11.5-25.6,25.6s5.8,18.8,14.2,23c4.1,2.7,9,4.3,14.3,4.3,14.2,0,25.6-11.5,25.7-25.6h0c0-10.1-5.8-18.8-14.3-23Z"
          />
          <path
            id="Tracé_1092"
            class="cls-6"
            d="M182.5,62.3c-11.4,0-20.6,9.2-20.6,20.6s9.2,20.6,20.6,20.6,20.6-9.2,20.6-20.6h0c0-11.4-9.2-20.6-20.6-20.6Z"
          />
          <circle
            id="Ellipse_2 right-eye-pupil"
            class="cls-7 pupil"
            cx="182.5"
            cy="83"
            r="13.9"
          />
          <path
            id=""
            class="cls-6"
            d="M180.8,76.2c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3,2.4-5.3,5.3-5.3h0c2.9,0,5.3,2.4,5.3,5.3Z"
          />
          <path
            class="cls-3"
            d="M106.4,30.9c7.2-.6,14.7-.9,22.3-.9,1.9,0,3.8,0,5.6,0,.3,0,.7,0,1,0,.6,0,1.2,0,1.7,0,5.3.2,5.5-5,.3-5.3,0,0-.1,0-.2,0-6.3-.3-12.7-.2-19,.2-.2,0-.4,0-.6,0-1,0-1.9.1-2.9.2-.4,0-.8,0-1.2,0-1,0-2,.2-3,.3-.2,0-.3,0-.5,0-1.2.1-2.4.3-3.6.4,0,0,0,0,0,0v4.9Z"
          />
          <path
            id="Tracé_1052"
            class="cls-8"
            d="M191.8,154.1c-1.2-.8-2.4-1.5-3.5-2.1-1.7,0-3.4.7-4.7,1.7-1.4,1.4-2.2,3.4-2.1,5.4-.2,2.1.2,4.2,1,6.1,1.3-4.3,4.2-9,9.3-11.1Z"
          />
          <path
            id="Tracé_1087"
            class="cls-8"
            d="M197.8,178.8l7.6,6.2c3-4.6,8-9.9,14.2-11.2-2.7-2.3-5.6-4.5-8.5-6.6-8.8.2-12.2,7.9-13.3,11.6Z"
          />
          <path
            id="Tracé_1090"
            class="cls-8"
            d="M198.2,202.2l7.9,17h0s2.4,5.1,2.4,5.1c.6.5,1.1,1.1,1.4,1.8,2-1.2,3.9-2.5,5.8-3.8-.5-9.5-7.6-19.5-10.4-23-2.4,1-4.8,2-7,3Z"
          />
          <path
            id="Tracé_1094"
            class="cls-8"
            d="M217.4,194.6c-.2,0-.4,0-.6,0-1,.4-2.1.8-3.2,1.2-.3.2-.7.4-1.1.4-.8.3-1.7.7-2.5,1,3.1,4.2,8.7,12.6,10.3,21.5,4.9-3.7,9.3-8.2,13-13.1-1.8-12.3-15.4-11.1-16-11.1Z"
          />
          <path
            id="Tracé_1096"
            class="cls-8"
            d="M186.7,169.8c1.5,1.2,4,3.3,7,5.7,1.8-4.7,5.5-10.1,11.8-12.3-2.6-1.9-5.2-3.6-7.6-5.2-8.6.3-10.6,8.6-11.1,11.8Z"
          />
          <path
            class="cls-6"
            d="M182.5,165.3c.4-1.3.9-2.6,1.6-3.9-1-.8-1.9-1.6-2.6-2.2-.2,2.1.2,4.2,1,6.1Z"
          />
          <path
            class="cls-6"
            d="M205.4,185c.6-1,1.4-2,2.2-3-2.6-2.4-5.3-4.9-8.1-7.4-.8,1.5-1.4,3-1.7,4.1l7.6,6.2Z"
          />
          <path
            class="cls-6"
            d="M193.6,175.4c.5-1.4,1.2-2.8,2.1-4.1-2.7-2.3-5.3-4.6-7.6-6.5-.9,1.9-1.3,3.8-1.4,5,1.5,1.2,4,3.3,7,5.7Z"
          />
          <path
            class="cls-5"
            d="M198.2,202.2l3.2,7c1.6-1.2,4.3-3,7.3-5-1.4-2.1-2.7-3.9-3.5-5-2.4,1-4.8,2-7,3Z"
          />
          <path
            class="cls-5"
            d="M217.4,194.6c-.2,0-.4,0-.6,0-1,.4-2.1.8-3.2,1.2-.3.2-.7.4-1.1.4-.8.3-1.7.7-2.5,1,.9,1.1,1.9,2.6,3,4.3,4-2.4,8.3-4.7,11.9-6-3.7-1.2-7.3-.9-7.6-.9Z"
          />
          <path
            id="Tracé_1091"
            class="cls-8"
            d="M209.4,188.2c1.3,1.1,2.5,2,3.2,2.6,5.9-2.3,11.5-4.2,13.7-4.4,1.4-.1,2.6.9,2.7,2.3,0,1-.5,2-1.4,2.4,3.9,1.5,7.1,4.4,9,8.2.4-1.1.5-2.3.5-3.5-.1-4.5-4.8-10.5-11.4-16.6-7.8-3-14,5.3-16.4,9Z"
          />
          <path
            class="cls-6"
            d="M209.4,188.2c1.3,1.1,2.5,2,3.2,2.6.9-.4,1.8-.7,2.7-1-1.2-1.3-2.6-2.7-4.1-4.2-.8,1-1.4,1.9-1.9,2.6Z"
          />
          <path
            id="Tracé_1062"
            class="cls-4"
            d="M81.8,236.1h-2.3c-1.4,0-2.5-1.1-2.5-2.5,0,0,0-.2,0-.2l2.1-22.1c-5.7,7.8-11.8,16.9-13.1,20.5.7,1.4,3.5,5.6,12,8.7,1-1.7,2.3-3.1,3.8-4.3Z"
          />
          <path
            class="cls-2"
            d="M79.1,211.3c-5.7,7.8-11.8,16.9-13.1,20.5.3.6,1,1.8,2.4,3.1l9.7-13,1-10.6Z"
          />
          <path
            id="Tracé_1065"
            class="cls-1"
            d="M37.2,99.1c1.3,9.8,3.8,14.7,7.5,17.9l-3.1-38.9c-4.2,4.7-5.6,11.6-4.3,21Z"
          />
          <path
            id="Tracé_1066"
            class="cls-3"
            d="M44.7,117l-2.8-35c-3.6,11.6-2.6,24.1,2.8,35Z"
          />
          <path
            id="Tracé_1080"
            class="cls-3"
            d="M238.4,85c-6.5,1.5-13.2,8.4-16.6,17.6-3.4,9.3-2.7,18.9,1.2,24.1-1.3-6.1-.5-14.3,2.6-22.7,3.1-8.4,7.8-15.1,12.7-19Z"
          />
          <path
            id="Tracé_1086"
            class="cls-3"
            d="M246.6,86.7c-4.7.4-12,7.4-16.3,19.1s-3.5,21.7,0,25.1c.2,0,.4,0,.6,0,6.6,0,13.8-6.2,17.9-15.1l-10.6-4.4c-1.9-.8-2.8-3-2-4.9.8-1.9,3-2.8,4.9-2l10.1,4.3c2.1-9.3.3-18.1-4.6-21.9Z"
          />
          <path
            class="cls-7"
            d="M158,203.7c0-.2-.2-.4-.4-.5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0-.1,0-4.3-3.9-9.3-7-14.7-9.1,0,0,0,0-.1,0,0,0,0,0,0,0-11.4-4.5-24.2-4.6-35.7-.2-.2,0-.3.1-.5.2,0,0,0,0,0,0-4.8,1.9-9.3,4.6-13.3,7.9-.7.6-1,1.6-.8,2.4,0,0,0,0,0,0,0,.7,1.5,3.2,2,3.7l12.1,12.1c.8.8,2.1,1,3.1.4,0,0,.2-.1.2-.2,10.1-7.5,24.1-7,33.7,1.1,1,.8,2.5.8,3.4-.1l12.1-12.1c.5-.5.8-1.2.7-2-.4-1.2-.9-2.3-1.6-3.4Z"
          />
          <path
            id="Tracé_1070"
            class="cls-3 gauge"
            d="M118.8,207.9s2-.5,6.7-.5,12.7,2.3,17.9,6.1l8.6-8.6c-2.7-2.1-5.6-4-8.8-5.4l-.6,1.6c-.5,1.3-1.9,2-3.2,1.5-1.3-.5-2-1.9-1.5-3.2l.6-1.8c-3.8-1.3-7.7-2-11.6-2.2v2.4c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5v-2.4c-3.7.2-7.4.9-11,2l.9,1.8c.6,1.2.1,2.8-1.1,3.4-1.2.6-2.8.1-3.4-1.1h0l-1.1-2.2c-2.8,1.2-5.4,2.8-7.9,4.6l8.6,8.7c3.6-2.3,7.5-3.8,11.7-4.6Z"
          />
          <path
            id="Tracé_1057"
            class="cls-3 gauge"
            d="M162.2,172c-.1-1.8-.5-3.5-1.2-5.2l-2.7,2.3c-1.1.9-2.7.7-3.5-.4-.8-1.1-.7-2.6.3-3.4l3.2-2.7c-2.1-2.4-4.9-4.1-8-4.9l-.3,3.5c-.1,1.3-1.2,2.3-2.5,2.3,0,0-.2,0-.2,0-1.4-.1-2.4-1.4-2.3-2.7h0s.3-3.5.3-3.5c-3.2.2-6.3,1.4-8.8,3.3l2.4,2.9c.9,1,.8,2.6-.2,3.5-1,.9-2.6.8-3.5-.2,0,0,0,0-.1-.1l-2-2.4c-1,1.5-1.7,3.2-2.2,4.9l31.4,3Z"
          />
          <path
            class="cls-7"
            d="M153.4,162.8c-1-1-2.5-1.1-3.4-.2,0,0,0,0-.1.1l-7.3,7.3c-.9.9-.9,2.4.1,3.4,0,0,.1.1.2.2,1,.8,2.4.8,3.3,0l7.3-7.3c.9-.9.9-2.4,0-3.4Z"
          />
          <path
            id="Tracé_1049"
            class="cls-8"
            d="M101.4,238.7h-12.2c-4.4,0-8.1,4.2-8.3,9.5l-2.8,65.2h17.4l2.6-65.4c.1-3.4,1.3-6.6,3.4-9.3Z"
          />
          <path
            class="cls-6"
            d="M92,238.7h-2.9c-4.4,0-8.1,4.2-8.3,9.5l-2.8,65.2h2.6c.4-6.7,3.4-58.1,3.4-63.9s6.2-9.5,8-10.7Z"
          />
          <path
            id="Tracé_1064"
            class="cls-8"
            d="M151.6,313.3h17.4l-3.6-65.1c-.2-3.4.7-6.7,2.7-9.5h-12.6c-1.8,0-3.6.8-4.8,2.1-1.7,1.9-2.6,4.5-2.4,7.1l3.4,65.4Z"
          />
          <path
            class="cls-6"
            d="M150.5,240.8c-1.7,1.9-2.6,4.5-2.4,7.1l3.4,65.4h3c-.6-9.8-3.5-57-3.5-63.9s5.1-9.7,6.9-10.7h-2.6c-1.8,0-3.6.8-4.8,2.1Z"
          />
          <circle class="cls-4" cx="203.9" cy="229.8" r="2.3" />
          <path
            id="Tracé_1056"
            class="cls-4"
            d="M139.7,236.1h-29.6c0,.6-.1,1.2-.2,1.8v19.8c0,8.2,4.5,15.1,9.8,15.1h25c-3.3-4.3-5.1-9.7-4.9-15.1v-21.6Z"
          />
          <path
            class="cls-2"
            d="M109.8,257.7c0,8.2,4.5,15.1,9.8,15.1h3.2c-2.6-1.7-6.5-4.9-8.5-9.5-1.4-3.3-.3-23.3,0-27.2h-4.3c0,.6-.1,1.2-.2,1.8v19.8Z"
          />
          <path
            id="Tracé_1073"
            class="cls-8"
            d="M50.8,184.4c4.9-1.6,9.9.6,12.9,2.5,1-1.8,2.1-3.6,3.5-5.2-4-1.9-7.3-4.9-9.5-8.7-5.4,5-9.8,10.1-12,14.9,1.4-1.6,3.1-2.8,5.1-3.5Z"
          />
          <path
            id="Tracé_1069"
            class="cls-8"
            d="M74.3,202.6c-1.5-.3-7.3-1.2-11.2,2-2.8,2.3-4.1,6.5-3.9,12.4,1.9,1.6,4,3.3,6.3,5,3.8-6,9-13.1,12.2-17.5-1-.5-2.2-1.1-3.5-1.8Z"
          />
          <path
            id="Tracé_1071"
            class="cls-8"
            d="M67.1,197.5c-1.7-1.4-3.1-3.2-4.2-5.1-2-1.6-6.7-4.5-10.5-3.3-3.8,1.3-5.8,6.5-6.8,11,1.6,3.9,4.6,8,8.8,12.3.5-5.2,2.4-9.1,5.6-11.7,2-1.6,4.5-2.7,7-3.2Z"
          />
          <path
            id="Tracé_1072"
            class="cls-8"
            d="M70.6,177.7c2.4-2.6,4.9-5,7.2-7.1-2.3-3.1-3.7-6.7-3.9-10.6-4.1,2.9-8.3,6.1-12.3,9.5,2.1,4.9,6.7,7.3,9,8.2Z"
          />
          <path
            id="Tracé_1075"
            class="cls-8"
            d="M83.3,165.8l1.2-12.8c-1.5,1-3.2,2-5,3.2-1.6,4.6.5,8.8,2.1,11.1.7-.6,1.2-1.1,1.7-1.5Z"
          />
          <path
            class="cls-5"
            d="M45.7,187.9c1.4-1.6,3.1-2.8,5.1-3.5.5-.2,1-.3,1.5-.4,2.1-2.5,4.7-5.2,7.6-8-.8-1-1.5-2-2.2-3.1-5.4,5-9.8,10.1-12,14.9Z"
          />
          <path
            class="cls-5"
            d="M59.3,216.9c1.9,1.6,4,3.3,6.3,5,.7-1,1.3-2.1,2.1-3.2-3.2-2.6-5.8-4.9-8.1-7.2-.3,1.6-.4,3.4-.3,5.4Z"
          />
          <path
            class="cls-5"
            d="M54.5,212.4c.2-1.9.6-3.6,1.1-5.2-5.6-6.6-7.1-11.4-7.3-14.4-1.3,2.1-2.1,4.8-2.7,7.3,1.6,3.9,4.6,8,8.8,12.3Z"
          />
          <path
            class="cls-5"
            d="M61.6,169.5c.5,1.2,1.2,2.3,1.9,3.2,3.6-3.2,7.4-6.3,10.9-9-.3-1.2-.5-2.4-.6-3.6-4.1,2.9-8.3,6.1-12.3,9.5Z"
          />
          <path
            class="cls-5"
            d="M79.5,156.2c-.5,1.4-.6,2.7-.5,4,2.1-1.6,3.8-2.9,5.2-3.9l.3-3.3c-1.5,1-3.2,2-5,3.2Z"
          />
          <polygon
            class="cls-2"
            points="90.1 146.5 82.3 231.2 88.7 231.2 95.8 146.8 90.1 146.5"
          />
          <path
            id="Tracé_1103"
            class="cls-2"
            d="M95.8,175.4c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c.2-1.4-.8-2.6-2.2-2.8-1.4-.2-2.6.8-2.8,2.2,0,0,0,.1,0,.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            id="Tracé_1104"
            class="cls-2"
            d="M105.1,175.4c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c.2-1.4-.8-2.6-2.2-2.8-1.4-.2-2.6.8-2.8,2.2,0,0,0,.1,0,.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            id="Tracé_1105"
            class="cls-2"
            d="M114.3,175.4c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c0-1.4-1-2.6-2.4-2.6-1.3,0-2.5.9-2.6,2.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            id="Tracé_1106"
            class="cls-7"
            d="M94.4,174.6c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c.2-1.4-.8-2.6-2.2-2.8-1.4-.2-2.6.8-2.8,2.2,0,0,0,.1,0,.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            id="Tracé_1107"
            class="cls-7"
            d="M103.7,174.6c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c.2-1.4-.8-2.6-2.2-2.8-1.4-.2-2.6.8-2.8,2.2,0,0,0,.1,0,.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            id="Tracé_1109"
            class="cls-7"
            d="M112.9,174.6c0,0,.1,0,.2,0,1.3,0,2.4-1,2.5-2.3l1.7-19c.2-1.4-.8-2.6-2.2-2.8-1.4-.2-2.6.8-2.8,2.2,0,0,0,.1,0,.2l-1.7,19c-.1,1.4.9,2.6,2.3,2.7Z"
          />
          <path
            class="cls-7"
            d="M113.5,199.9c-1,.9-1.1,2.5-.1,3.5,0,0,0,0,.1.1l7.9,7.9c1,1,2.6,1,3.5,0,0,0,.1-.1.2-.2.8-1,.8-2.5-.1-3.4l-7.9-7.9c-.9-1-2.5-1.1-3.5-.1Z"
          />
        </g>
      </g>
    </svg>
  </div>
</infl-widget-wrapper>
